<div class="fdx-c-modal">
    <div class="fdx-c-modal__backdrop"></div>
    <div class="fdx-c-modal__main" [ngClass]="{
        'fdx-c-modal__main--small': modalDialogType==='SMALL',
        'fdx-c-modal__main--medium':modalDialogType==='MEDIUM',
        'fdx-c-modal__main--large':(modalDialogType==='LARGE'),
        'fdx-c-modal__main--full-height': modalDialogType==='FULL_HEIGHT',        
        'fdx-c-modal__main--': modalDialogType==='DEFAULT'
      }">
        <div class="fdx-c-modal__body">
            <!--<h3 class="fdx-c-modal__title">SUCCESS</h3>-->
            <div class="fdx-c-notification__header">
                <svg class="fdx-c-icon" aria-hidden="true">
                    <use href="#check-mark-circle"></use>
                </svg>                
            </div>
            <div class="fdx-c-modal__description" translate>
                 <br>   
                {{modalDialogBodyContent}}
            </div>
            <div class="fdx-o-grid__row--guttered-small text-center">
                <button  type="button" *ngIf="isButtonShow"
                class="fdx-c-button fdx-c-button--primary fdx-c-button--primary-condensed fdx-u-mt--4"
                (click)="buttonAction()">{{ buttonText }}</button>
            </div>
        </div>
    </div>
</div>